import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectGatewaysListItems } from "../../../../../redux/gateways/selector";
import { gateways } from "../../../../../redux/gateways/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const EdgeGateways = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const gatewayItems = useSelector(selectGatewaysListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
        filterType: 'text' },
        { field: 'DBNIEName', headerName: 'DBNIE Name'},
        { field: 'DBNPName', headerName: 'DBNP Name'},
        {field: 'DBNPRegistryName', headerName: 'DBNP Registry Name'},
        {field: 'OrgRegistryName', headerName: 'OrgRegistry Name'},
        { field: 'DBAName', headerName: 'DBA Name', searchField: 'Name', filter: true,
          filterType: 'text'},
          { field: 'TotalNoOfGatewayRegistries', headerName: 'Total No Of GatewayRegistries', searchField: 'TotalNoOfGatewayRegistries', filter: true,
            filterType: 'text'
          },
          { field: 'Type', headerName: 'DBA Type', searchField: 'Type', filter: true, filterType: 'text' },
    

    ]);
  }

  const getTypeName = (data: any) => {
    if (Array.isArray(data)) {
        return data.join('\n'); 
    }
    return data;
};
  const fetchGatewaysList = () => {
    dispatch(gateways.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/fetch`,
      entity: 'gateways',
      jsonData: {
        Context: {},
        Records: [
          {
           
          },
        ],
        Pagination: {
          PageNumber: 1,
          PageSize: 100,
          SortField: "DisplayOrder",
          SortOrder: "desc",
        },
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchGatewaysList()
  }, [pageData,pageSize])


  const handleEdit = (data: any) => {
    navigate(`${data?.GatewayId}/${data?.TenantId}`)
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  
  const handleReloadData = () => {
    fetchGatewaysList();
  }
 
  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(gateways.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/fetch`,
      entity: 'gateways',
      jsonData: {
        Context: {},
        Records: [
          {
           
          },
        ],
        Pagination: {
         "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
        },
      }
        
      }))

  }

  const handleSubscribeTrigger = async () => {
    console.log('Trigger subscription to registry')
  }

  
  return (
    <>
 
      {gatewayItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs}
          rowData={gatewayItems?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          paginationData={gatewayItems?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          handleSubscribeTrigger={handleSubscribeTrigger}
          isEnableSubscribeTrigger={true}
          headingName="Gateways"
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
        />
      }
    </>
  );
};

export default EdgeGateways;


